{
    "name": "@department-of-veterans-affairs/platform-site-wide",
    "version": "1.0.0",
    "scripts": {
      "demo":"echo DEMOING $npm_package_name v $npm_package_version with WORKSPACES"
    },
    "exports": {
      "." :"./exportsFile.js",
      "./accessible-VCL-modal": "./accessible-VCL-modal.js",
      "./actions": "./user-nav/actions/index.js",
      "./actionTypes": "./feature-toggles/actionTypes.js",
      "./AutoSSO": "./user-nav/containers/AutoSSO.jsx",
      "./feature-toggles/reducers": "./feature-toggles/reducers/index.js",
      "./header": "./header/index.js",
      "./legacy/mega-menu": "./legacy/mega-menu.js",
      "./LoadingButton": "./loading-button/LoadingButton.jsx",
      "./mega-menu": "./mega-menu/index.js",
      "./m-downtime-notification": "./sass/modules/m-downtime-notification.scss",
      "./m-footer": "./sass/modules/m-footer.scss",
      "./m-header": "./sass/modules/m-header.scss",
      "./m-layers": "./sass/modules/m-layers.scss",
      "./m-overrides": "./sass/modules/m-overrides.scss",
      "./main": "./index.js",
      "./menu": "./legacy/menu.js",
      "./mobile-menu-button": "./mobile-menu-button/index.js",
      "./MobileAppCallout": "./alerts/MobileAppCallout.jsx",
      "./moment-setup": "./moment-setup.js",
      "./PageNotFound": "./user-nav/components/PageNotFound.jsx",
      "./reducers": "./mega-menu/reducers/index.js",
      "./sass/user-nav": "./user-nav/sass/user-nav.scss",
      "./selectors": "./feature-toggles/selectors.js",
      "./static-drupal-data": "./hooks/static-drupal-data.js",
      "./style": "./sass/style.scss",
      "./user-nav": "./user-nav/index.js",
      "./user-nav/reducers": "./user-nav/reducers/index.js",
      "./utilities": "./mhv/utilities.js",
      "./va-footer": "./va-footer/index.js",
      "./va-medallia-style": "./sass/va-medallia-style.scss",
      "./wc-loader": "./wc-loader.js",
      "./wizard": "./wizard/index.js"
    },
    "peerDependencies": {
      "react": "*",
      "@department-of-veterans-affairs/component-library": "*",
      "url-search-params": "*",
      "react-redux": "*",
      "prop-types": "*",
      "chai": "*",
      "enzyme": "*",
      "sinon": "*",
      "moment": "*",
      "date-fns": "*",
      "lodash-es": "*",
      "react-dom": "*",
      "@testing-library/user-event": "*",
      "classnames": "*",
      "node-fetch": "*",
      "append-query": "*",
      "reselect": "*",
      "core-js": "*"
    },
    "license": "MIT",
    "private": true
  }